import { Col, Row } from "antd";
import { get, set } from "lodash";
import moment from "moment";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { MdOutlineFileUpload } from "react-icons/md";
import Button from "shared/components/Button";
import Form from "shared/components/Form";
import Input from "shared/components/Input";
import Label from "shared/components/Label";
import { NAME_SPACES } from "shared/locales/constants";
import { ATTACHMENT_TYPES, RELATIONSHIP } from "utils/constants";

const Children = ({
  values,
  onFileRemove,
  setFieldValue,
  setPercent,
  disabled,
  subscription,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const SUBSCRIPTION = t("SUBSCRIPTION", { returnObjects: true });
  const children = useMemo(
    () =>
      get(subscription, "project.contact.relatedPersons", []).filter(
        (person) => person.relationship === RELATIONSHIP.CHILD,
      ),
    [],
  );

  return (
    <div className="subscription-form--wrapper">
      <div className="grid--1">
        {children.map((child, index) => {
          const childAge = moment().diff(
            get(child, "identity.user.birthDate"),
            "years",
          );
          const isOver16 = childAge >= 16;
          const isOver18 = childAge >= 18;
          return (
            <Form
              type="vertical"
              title={`${SUBSCRIPTION.FORM.PROOF.CHILD} ${index + 1}`}
              key={`${SUBSCRIPTION.FORM.PROOF.CHILD} ${index + 1}`}
            >
              <Row gutter={[16, 16]}>
                <Col lg={24} xs={24}>
                  <div className="subscription-form--group-label">
                    <Label
                      label={
                        SUBSCRIPTION.FORM.PROOF.LMF
                          .HEALTH_INSURANCE_RIGHTS_CERTIFICATE
                      }
                      icon={<MdOutlineFileUpload size={16} />}
                      required={isOver16}
                    />
                  </div>
                </Col>
                <Col lg={24} xs={24}>
                  <div className="subscription-form--custom-upload">
                    <Input
                      type="file"
                      variant="uploader"
                      validTypes={SUBSCRIPTION.FORM.PROOF.ALLOWED_FILES_TYPE}
                      onUpload={(fileList) => {
                        setFieldValue(
                          `proof.children.${get(child, "identity.user.id")}.${
                            ATTACHMENT_TYPES.HEALTH_INSURANCE_RIGHTS_CERTIFICATE
                          }`,
                          fileList,
                        );
                        setPercent(
                          set(
                            values,
                            `proof.children.${get(child, "identity.user.id")}.${
                              ATTACHMENT_TYPES.HEALTH_INSURANCE_RIGHTS_CERTIFICATE
                            }`,
                            fileList,
                          ),
                        );
                      }}
                      onFileRemove={onFileRemove}
                      fileList={get(
                        values,
                        `proof.children.${get(child, "identity.user.id")}.${
                          ATTACHMENT_TYPES.HEALTH_INSURANCE_RIGHTS_CERTIFICATE
                        }`,
                        [],
                      )}
                    >
                      <Row align="center">
                        <Button type="primary--link">
                          {SUBSCRIPTION.FORM.PROOF.ACTION.ADD}
                        </Button>
                      </Row>
                    </Input>
                  </div>
                </Col>
              </Row>
              {isOver18 && (
                <Row gutter={[16, 16]}>
                  <Col lg={24} xs={24}>
                    <div className="subscription-form--group-label">
                      <Label
                        label={
                          SUBSCRIPTION.FORM.PROOF.LMF.CHILDREN_DEPENDENT_PROOF
                        }
                        icon={<MdOutlineFileUpload size={16} />}
                        required={isOver18}
                      />
                    </div>
                  </Col>
                  <Col lg={24} xs={24}>
                    <div className="subscription-form--custom-upload">
                      <Input
                        type="file"
                        variant="uploader"
                        validTypes={SUBSCRIPTION.FORM.PROOF.ALLOWED_FILES_TYPE}
                        onUpload={(fileList) => {
                          setFieldValue(
                            `proof.children.${get(child, "identity.user.id")}.${
                              ATTACHMENT_TYPES.CHILD_DEPENDENT_PROOF
                            }`,
                            fileList,
                          );
                          setPercent(
                            set(
                              values,
                              `proof.children.${get(
                                child,
                                "identity.user.id",
                              )}.${ATTACHMENT_TYPES.CHILD_DEPENDENT_PROOF}`,
                              fileList,
                            ),
                          );
                        }}
                        onFileRemove={onFileRemove}
                        fileList={get(
                          values,
                          `proof.children.${get(child, "identity.user.id")}.${
                            ATTACHMENT_TYPES.CHILD_DEPENDENT_PROOF
                          }`,
                          [],
                        )}
                      >
                        <Row align="center">
                          <Button type="primary--link">
                            {SUBSCRIPTION.FORM.PROOF.ACTION.ADD}
                          </Button>
                        </Row>
                      </Input>
                    </div>
                  </Col>
                </Row>
              )}
              <Row gutter={[16, 16]}>
                <Col lg={24} xs={24}>
                  <div className="subscription-form--group-label">
                    <Label
                      label={SUBSCRIPTION.FORM.PROOF.LMF.RIB_SERVICE}
                      icon={<MdOutlineFileUpload size={16} />}
                    />
                  </div>
                </Col>
                <Col lg={24} xs={24}>
                  <div className="subscription-form--custom-upload">
                    <Input
                      type="file"
                      variant="uploader"
                      validTypes={SUBSCRIPTION.FORM.PROOF.ALLOWED_FILES_TYPE}
                      onUpload={(fileList) => {
                        setFieldValue(
                          `proof.children.${get(child, "identity.user.id")}.${
                            ATTACHMENT_TYPES.BANK_ACCOUNT_DETAILS_FOR_PAYMENT
                          }`,
                          fileList,
                        );
                        setPercent(
                          set(
                            values,
                            `proof.children.${get(child, "identity.user.id")}.${
                              ATTACHMENT_TYPES.BANK_ACCOUNT_DETAILS_FOR_PAYMENT
                            }`,
                            fileList,
                          ),
                        );
                      }}
                      onFileRemove={onFileRemove}
                      fileList={get(
                        values,
                        `proof.children.${get(child, "identity.user.id")}.${
                          ATTACHMENT_TYPES.BANK_ACCOUNT_DETAILS_FOR_PAYMENT
                        }`,
                        [],
                      )}
                    >
                      <Row align="center">
                        <Button type="primary--link">
                          {SUBSCRIPTION.FORM.PROOF.ACTION.ADD}
                        </Button>
                      </Row>
                    </Input>
                  </div>
                </Col>
              </Row>
            </Form>
          );
        })}
      </div>
    </div>
  );
};

export default Children;
